export default {
  'Ensuring supply reliability and resiliency': [
    {
      name: 'Strategic plans',
      params: {
        type: ['Strategic plans'],
      },
      note: 'Many countries develop a national strategy or policy roadmap identifying key priority actions for later policy development, often captured in a strategic plan or other public document.',
    },
    {
      name: 'Strategic mineral lists',
      params: {
        type: ['Minerals list'],
      },
      note: 'Relevant authorities or governments are responsible for drawing up lists of all minerals designated strategic or critical. Sometimes referred to as lists of critical raw materials, they often indicate why these minerals are of particular importance and outline related policy provisions. ',
    },
    {
      name: 'International coordination mechanisms',
      params: {
        type: ['International collaboration'],
      },
      note: 'Countries may join bilateral or regional mechanisms to co ordinate supply security efforts. These mechanisms may involve sharing best practices as well as collaborating on research and development, purchases, market reserves and joint stockpiling.',
    },
    {
      name: 'Stockpiling mechanisms',
      params: {
        type: ['Strategic stockpile'],
      },
      note: 'Policies can be designed to insure against risks such as supply chain disruptions, price spikes, etc. by retaining (and maintaining) reserves of extracted critical minerals. Stockpiling systems can be associated with release mechanisms triggered by supply disruptions.',
    },
    {
      name: 'Public investment',
      params: {
        type: [
          'Equity',
          'Direct equity investment',
          'Investment in assets',
          'State-owned enterprise',
          'Public procurement',
        ],
      },
      isOr: true,
      note: 'To develop new supply sources, countries may directly invest government funds through state-owned enterprises, by making public equity investments in private companies or projects, or by employing government procurement mechanisms to purchase output from a specific source for national stockpiles or other government usage.',
    },
  ],
  'Promoting exploration, production and innovation': [
    {
      name: 'Financing',
      params: {
        type: ['Finance', 'Loans / debt finance', 'Loan guarantee', 'Grants'],
      },
      isOr: true,
      note: 'Countries may use direct funding to support the development of domestic supplies through mechanisms such as grants, preferential loans or loan guarantees. These financial incentives can be administered to pre-existing or new extraction projects.',
    },
    {
      name: 'Tax incentives',
      params: {
        type: ['Differential tax treatment', 'Investment tax incentives'],
      },
      isOr: true,
      note: 'Countries may use favourable tax schemes to incentivise domestic production. They may also allow tax deductions for specific types of investment.',
    },
    {
      name: 'Geological surveys',
      params: {
        type: ['Geological surveys'],
      },
      note: 'Countries may develop geological survey data on existing mineral reserves and make these data available both domestically and abroad. Geological data can be made directly accessible to the public, or governments can offer public funding for exploration and surveying activities.',
    },
    {
      name: 'Recycling support',
      params: {
        technology: ['Recycling and end-of-life'],
      },
      note: 'Policies that target development of a secondary-material supply market with adequate processing capability may include research and development funding, regulations to require or increase collection rates, and other support measures for new recycling facilities.',
    },
    {
      name: 'Innovation funding',
      params: {
        topic: ['Technology R&D and innovation'],
      },
      note: 'Measures designed to accelerate technological progress and innovation, generally through funding and information-sharing initiatives, may include direct funding through grants or subsidies for research, development, demonstration and deployment.',
    },
  ],
  'Encouraging sustainable and responsible practices': [
    {
      name: 'Environmental standards',
      params: {
        type: ['Environmental impact assessment', 'Environmental standards'],
      },
      isOr: true,
      note: 'Policies designed to safeguard or protect the local, regional or global environment can include air and water pollution standards specific to the mining sector, standards for managing tailings, environmental impact assessments and environmental management plans.',
    },
    {
      name: 'Transparency norms',
      params: {
        type: ['Public disclosure requirements'],
      },
      note: 'Rules and regulations designed to provide public information on the extractive industry (such as those required under the Extractive Industries Transparency Initiative (EITI) Standard) may include requirements to publish licences or permits, production data, and tax collection and distribution rates.',
    },
    {
      name: 'Due diligence obligations',
      params: {
        type: ['Due diligence'],
      },
      note: 'Requirements for companies to undertake supply chain due diligence in line with relevant international guidance (including the OECD Due Diligence Guidance for Responsible Supply Chains of Minerals from Conflict-Affected and High-Risk Areas) generally involve adopting risk management systems to identify, assess, report and, ultimately, minimise or eliminate environmental and social impacts.',
    },
    {
      name: 'Inclusivity and gender policies',
      params: {
        type: ['Inclusivity and gender'],
      },
      note: 'Policies can be designed to encourage gender diversity, engagement with indigenous communities, and inclusion of impacted community members’ views and feedback.',
    },
    {
      name: 'Permitting regimes',
      params: {
        type: ['Permitting processes', 'Resource rights', 'Regulatory reform'],
      },
      isOr: true,
      note: 'Governments can devise general or specific permitting or licensing regimes for mineral and metal exploitation, and can take special measures to streamline or enhance the process.',
    },
  ],
};
